import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';

import { StoreStockRecallRequestSearchCriteria } from '../../model/store-stock-recall-list.model';
import { loadStoreStockRecallListResponse, storeStockRecallViewAction } from './store-stock-recall-list.action';

export interface StoreStockRecallListState extends EntityState<any> {
  isLoading: boolean;
  selected: any[];
  criteriaObject: StoreStockRecallRequestSearchCriteria;
  totalElements: number;
  totalPages: number;
  auditLogs: any;
  viewStoreStockRecall: any;
}

export const adapter: EntityAdapter<any> = createEntityAdapter<any>({
  selectId: (model: any) => model.docNo
});

export const initialStoreStockRecallListState: StoreStockRecallListState = adapter.getInitialState({
  isLoading: false,
  criteriaObject: {
    page: 0,
    size: 20,
    status: ''
  },
  selected: [],
  totalElements: 0,
  totalPages: 20,
  auditLogs: [],
  viewStoreStockRecall: null
});

export const storeStockRecallListReducer = createReducer(
  initialStoreStockRecallListState,
  on(loadStoreStockRecallListResponse, (state, action): StoreStockRecallListState => {
    return {
      ...state,
      selected: action.data?.content,
      totalElements: action.data?.totalElements,
      isLoading: false,
      criteriaObject: {
        ...state.criteriaObject,
        page: action.data?.page,
        size: action.data?.size
      }
    };
  }),
  on(storeStockRecallViewAction.view, (state): StoreStockRecallListState => {
    return { ...state, isLoading: true };
  }),
  on(storeStockRecallViewAction.viewResponse, (state, action): StoreStockRecallListState => {
    return { ...state, viewStoreStockRecall: action.response, isLoading: false };
  }),
  on(storeStockRecallViewAction.resetView, (state): StoreStockRecallListState => {
    return { ...state, viewStoreStockRecall: null };
  })
);
